import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Box, Chip, Grid, MenuItem, Select } from '@mui/material';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { getSmsLogsForCandidateid } from 'wisestep-api';
import {
  Item,
  WsColors,
  WsIconText,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard';
import { useUserContext } from '../../../context';

interface IMsg {
  direction: string;
  jobTitle: string | null;
  messageStatus: string;
  createdBy: string;
  createdOn: string;
  creditConsumed: number;
  message: string;
  to: string;
  jobId: string;
  candidateName: string;
  from: string;
}

interface ICandidateSMSLogsUI {
  phoneNumbers: string[];
  candidateId: string;
}

const CandidateSmsLogsUI = ({ phoneNumbers, candidateId }: ICandidateSMSLogsUI) => {
  const user = useUserContext();
  const [msgList, setMsgList] = useState<IMsg[]>([]);
  const [phone, setPhone] = useState<string>(phoneNumbers[0]);

  useEffect(() => {
    (async () => {
      if (isEmpty(msgList)) {
        // const phoneData = phone.replace(/\s/g, '');
        // const response = await getSmsLogs(
        //   phoneData.includes('+1') ? phoneData : `+1${phoneData}`,
        //   1
        // );
        // if (response.data && response.data.length) {
        //   setMsgList(response.data);
        // }
        const response = await getSmsLogsForCandidateid(candidateId);
        const tobeFilteredLogs = response.data;
        setMsgList(getMsgList(tobeFilteredLogs));
      }
    })();
  }, []);

  const getMsgList = (tobeFilteredLogs: any[]): IMsg[] => {
    return tobeFilteredLogs.map(
      (log): IMsg => ({
        direction: log.direction,
        jobTitle: log.jobTitle ?? null,
        messageStatus: log.deliveryStatus,
        createdBy: log.recruiterId,
        createdOn: new Date(log.createdOn).toISOString(),
        creditConsumed: log.creditConsumed,
        message: log.body,
        to: log.to,
        jobId: log.jobId,
        candidateName: log.candidateId,
        from: log.from,
      })
    );
  };

  const getMessageStatusTextColor = (status: string) => {
    let color = WsColors.Green400;
    switch (status) {
      case 'DELIVERED':
        color = WsColors.Green400;
        break;
      case 'DELIVERY_FAILED':
        color = WsColors.Red400;
        break;
      case 'SENT':
        color = WsColors.Green400;
        break;
      case 'SENDING_FAILED':
        color = WsColors.Red400;
        break;
      default:
        color = WsColors.Yellow500;
        break;
    }
    return color;
  };

  const getMessageStatus = (msgStatus: string) => {
    let status = '';
    switch (msgStatus) {
      case 'DELIVERED':
        status = 'Delivered';
        break;
      case 'RECEIVED':
        status = 'Received';
        break;
      case 'DELIVERED_FAILED':
        status = 'Delivered Failed';
        break;
      case 'DELIVERED_UNCONFIRMED':
        status = 'Delivered Unknown';
        break;
      case 'SENT':
        status = 'Sent';
        break;
      case 'SENDING_FAILED':
        status = 'Failed';
        break;
      case 'UNDELIVERED':
        status = 'Undelivered';
        break;
      case 'QUEUED':
        status = 'Queued';
        break;
    }
    return status;
  };

  const getMessageStatusIcon = (status: string) => {
    let icon = <></>;
    switch (status) {
      case 'DELIVERED':
        icon = <DoneAllIcon sx={{ color: `${WsColors.Green400} !important` }} />;
        break;
      case 'SENT':
        icon = <DoneIcon sx={{ color: `${WsColors.Green400} !important` }} />;
        break;
      case 'QUEUED':
        icon = <RestartAltIcon sx={{ color: `${WsColors.Yellow400} !important` }} />;
        break;
      case 'SENDING_FAILED':
        icon = <ErrorOutlineIcon sx={{ color: `${WsColors.Red400} !important` }} />;
        break;
      default:
        icon = <></>;
        break;
    }
    return icon;
  };

  return (
    <>
      <Select
        labelId="select-phone-number"
        id="select-phone-number"
        value={phone}
        label="phone"
        sx={{ float: 'right', mb: '15px' }}
        onChange={(e) => setPhone(e.target.value)}
      >
        {phoneNumbers.map((phone, index) => (
          <MenuItem key={index} value={phone}>
            {phone}
          </MenuItem>
        ))}
      </Select>
      {!isEmpty(msgList) ? (
        <>
          {msgList.map((msg, index) => (
            <Grid
              key={index}
              container
              mt={2}
              justifyContent={msg.direction === 'INBOUND' ? 'start' : 'end'}
            >
              <Box
                sx={{
                  borderRadius: '25px',
                  background:
                    msg.direction === 'INBOUND' ? WsColors.TheBlues100 : WsColors.TertiaryShades50,
                  width: '70%',

                  display: 'block',
                }}
              >
                <Item>
                  {msg.messageStatus != 'RECEIVED' && msg.jobTitle && (
                    <Box mb={1} ml={1} sx={{ width: '100%' }}>
                      <WsIconText
                        opacity={true}
                        text={
                          msg.jobTitle.length > 44
                            ? msg.jobTitle.substr(0, 44).split(' ').join(' ') + '...'
                            : msg.jobTitle
                        }
                        onClick={() =>
                          window.open(
                            `${window.location.origin}/jobs-crm/${msg.jobId}/false/0/pipeline`
                          )
                        }
                        icon={<BusinessCenterIcon />}
                        popOverText="Job title"
                        textCursor="pointer"
                        textColor={WsTypoColors.QUINARY}
                        textSize={WsTypoVariants.SUB_TITLE}
                      />
                    </Box>
                  )}
                  <WsTypography bold color={WsTypoColors.SENARY}>
                    {msg.message}
                  </WsTypography>
                  <Grid container mt={1}>
                    <Grid item xs={msg.direction != 'INBOUND' ? 6 : 12}>
                      <WsTypography
                        variant={WsTypoVariants.BODY2}
                        color={WsTypoColors.QUINARY}
                      >{` ${msg.direction != 'INBOUND' ? 'Sent by' : 'Sent to'} : ${
                        msg.direction != 'INBOUND'
                          ? `${msg.createdBy}`
                          : `${user.userDTO?.firstName}(${msg.from})`
                      }`}</WsTypography>
                      <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
                        {dayjs(msg.createdOn).format('DD MMM YY, HH:mm')}
                      </WsTypography>
                    </Grid>
                    {msg.direction !== 'INBOUND' && (
                      <Grid item xs={6}>
                        <Chip
                          size="small"
                          icon={getMessageStatusIcon(msg.messageStatus)}
                          label={getMessageStatus(msg.messageStatus)}
                          sx={{
                            float: 'right',
                            borderRadius: 1,
                            mb: 2,
                            mt: 1,
                            backgroundColor: WsColors.TertiaryShades50,
                            color: getMessageStatusTextColor(msg.messageStatus),
                          }}
                        />
                        {msg.creditConsumed > 0 && (
                          <Chip
                            size="small"
                            label={`Credits - ${msg.creditConsumed}`}
                            sx={{
                              float: 'right',
                              borderRadius: 1,
                              mb: 2,
                              mt: 1,
                              mr: 1,
                              backgroundColor: WsColors.TheBlues500,
                              color: WsColors.White,
                            }}
                          />
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Item>
              </Box>
            </Grid>
          ))}
        </>
      ) : (
        <NoDataFoundCard text="No SMS found with this number" />
      )}
    </>
  );
};

export default CandidateSmsLogsUI;
